export const saveInteractionAttributes = async (
  accountId: number,
  visitorId: string,
  attributes: Record<string, any>,
) => {
  const url = `${process.env.REACT_APP_SIGNALLING_API_URL}/accounts/${accountId}/visitors/${visitorId}/interaction-attributes`;
  await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(attributes),
  });
};
